import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";


const membershipMix = [
  { name: "Premium Annual", value: 38, color: "var(--color-primary)" },
  { name: "Premium Monthly", value: 27, color: "var(--color-secondary)" },
  { name: "Standard Monthly", value: 22, color: "var(--color-accent)" },
  { name: "Basic Monthly", value: 13, color: "#9CA3AF" },
];

const channelData = [
  { channel: "Walk-in", leads: 142, converted: 89, rate: 62.7 },
  { channel: "Referral", leads: 98, converted: 71, rate: 72.4 },
  { channel: "Social Media", leads: 203, converted: 94, rate: 46.3 },
  { channel: "Website", leads: 167, converted: 78, rate: 46.7 },
];

export default function QuickStatsRow() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
      {/* Membership Mix */}
      <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-[var(--radius-md)] p-4 md:p-5 shadow-[var(--shadow-sm)]">
        <h3 className="text-sm font-semibold text-[var(--color-foreground)] font-[var(--font-heading)] mb-4">Membership Mix</h3>
        <div className="flex items-center gap-4">
          <div className="w-28 h-28 flex-shrink-0">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={membershipMix} cx="50%" cy="50%" innerRadius={30} outerRadius={52} dataKey="value" strokeWidth={0}>
                  {membershipMix?.map((entry, i) => <Cell key={i} fill={entry?.color} />)}
                </Pie>
                <Tooltip formatter={(v) => [`${v}%`, ""]} contentStyle={{ fontSize: "11px", fontFamily: "var(--font-caption)", borderRadius: "8px", border: "1px solid var(--color-border)" }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="flex-1 space-y-2">
            {membershipMix?.map((item, i) => (
              <div key={i} className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 min-w-0">
                  <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: item?.color }} />
                  <span className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)] truncate">{item?.name}</span>
                </div>
                <span className="text-xs font-semibold text-[var(--color-foreground)] font-[var(--font-data)] flex-shrink-0">{item?.value}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Lead Conversion */}
      <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-[var(--radius-md)] p-4 md:p-5 shadow-[var(--shadow-sm)]">
        <h3 className="text-sm font-semibold text-[var(--color-foreground)] font-[var(--font-heading)] mb-4">Lead Conversion by Channel</h3>
        <div className="space-y-2.5">
          {channelData?.map((item, i) => (
            <div key={i} className="flex items-center gap-3">
              <span className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)] w-20 flex-shrink-0">{item?.channel}</span>
              <div className="flex-1 h-2 bg-[var(--color-muted)] rounded-full overflow-hidden">
                <div className="h-full rounded-full bg-[var(--color-primary)] transition-all" style={{ width: `${item?.rate}%` }} />
              </div>
              <div className="flex items-center gap-1 flex-shrink-0">
                <span className="text-xs font-semibold text-[var(--color-foreground)] font-[var(--font-data)] w-10 text-right">{item?.rate}%</span>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4 pt-3 border-t border-[var(--color-border)] flex items-center justify-between">
          <span className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)]">Total Leads: 610</span>
          <span className="text-xs font-semibold text-[var(--color-success)] font-[var(--font-caption)]">332 Converted (54.4%)</span>
        </div>
      </div>
    </div>
  );
}